import React, { useState } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import CipHeader from "../Components/CipHeader";
import cogoToast from "cogo-toast";

import { kaReducer, Table } from "ka-table";
import { search, loadData, updateData } from "ka-table/actionCreators";
import { ActionType, SortingMode, PagingPosition } from "ka-table/enums";
import newOrderService from "../services/new-order-service";
import "react-loader-spinner/dist/loader/css/react-spinner-loader.css";
import Loader from "react-loader-spinner";
const tablePropsInit = {
  columns: [
    { key: "drg_name", title: "Drug Name" },
    { key: "pat_name", title: "Patient Name" },
    { key: "fac_name", title: "Facility Name" },
    { key: "rxf_ord_sig", title: "Sig" },
    { key: "days_supply", title: "Days Supply" },
    { key: "alt_drg_name", title: "Clinical Alternative Drug" },
    { key: "alt_qty_dose", title: "Clinical Alternative Qty per dose" },
    { key: "alt_qty_dose1", title: "Clinical Alternative Qunatity per dose", style: { display: "none" } },
    { key: "alt_frequency", title: "Clinical Alternative Frequency" },
    { key: "notes", title: "Clinical Alternative Notes" },
    { key: "Actions", title: "Actions" },
  ],
  singleAction: loadData(),
  sortingMode: SortingMode.Single,
  rowKeyField: "id",
  search: ({ searchText, rowData, column }) => {
    if (column.key === "passed") {
      return (
        (searchText === "false" && !rowData.passed) ||
        (searchText === "true" && rowData.passed)
      );
    }
  },
  paging: {
    enabled: true,
    pageIndex: 0,
    pageSize: 10,
    position: PagingPosition.Bottom,
  },
};

const NonFormList = ({ history }) => {
  const [loading, setLoading] = useState(false);

  const CustomCell = ({ rowData }) => {
    var drug = rowData?.alt_drg_name?.trim() ? " with the " +  rowData?.alt_drg_name : "";
    const message = `Please DC this order in your eHR and place a new order${drug} and then void the order`;
    return (
      <div className="action_btns">
        <span className="inline-block mr-3">
          <button
          className={
            rowData?.message_type === "CIPSREMOTE"
              ? "opacity-50 cursor-not-allowed text-white w-full sm:w-auto  px-2  mt-1 sm:mt-5 bg-login_btn rounded text-xs font-medium capitalize focus:outline-none"
              : "text-white w-full sm:w-auto  px-2  mt-1 sm:mt-5 bg-login_btn rounded text-xs font-medium capitalize focus:outline-none"
          }
            onClick={() => onSubmit(rowData?.rxf_con_id, "APPROVE")}
            title={ rowData?.message_type === "CIPSREMOTE" ? message : "APPROVE ALTERNATIVE"}
          >
            APPROVE ALTERNATIVE
          </button>
        </span>
        <span className="inline-block mr-3">
          <button
            className="text-white w-full sm:w-auto px-2  mt-1 sm:mt-5 bg-rose rounded text-xs font-medium capitalize focus:outline-none"
            onClick={() => onSubmit(rowData?.rxf_con_id, "DENY")}
            title="DENY ALTERNATIVE"
          >
            DENY ALTERNATIVE
          </button>
        </span>
      </div>
    );
  };
  const onSubmit = async (id, action) => {
    try {
      setLoading(true);

      await newOrderService.submitForm(id, action);
      let resp = await newOrderService.getNonForms();
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      dispatch(updateData(resp));
      setLoading(false);
    } catch (e) {
      const { hide } = cogoToast.error(
        "Error submitting data. Please try after sometime.",
        {
          hideAfter: 15,
          onClick: () => {
            hide();
          },
        }
      );
      setLoading(false);
    }
  };

  const [tableProps, changeTableProps] = useState(tablePropsInit);
  const dispatch = async (action) => {
    changeTableProps((prevState) => kaReducer(prevState, action));
    if (action.type === ActionType.LoadData) {
      setLoading(true);
      let resp = await newOrderService.getNonForms();
      resp?.sort(
        (d1, d2) =>
          new Date(d2.updatedAt).getTime() - new Date(d1.updatedAt).getTime()
      );
      setLoading(false);
      dispatch(updateData(resp));
    }
  };

  return (
    <>
      <CipHeader />
      <div
        className={`inline-block customtop absolute z-50 ${
          loading ? "show" : "hidden"
        }`}
      >
        <Loader
          type="Oval"
          color="#00BFFF"
          height={50}
          width={50}
          timeout={300000} //3 secs
        />
      </div>
      <div className="bg-white mr-6 ml-6 mx-auto mt-6 mb-4 rounded shadow-md">
        <div className="tableHeader flex clearboth shadow-md py-8 pl-3">
          <div className="w-1/2 text-darkclr font-semibold leading-10 ">
            <span className="text-xl">NON FORMS</span>
          </div>
          <div className="w-full sm:w-1/2 text-right">
            <span className="relative">
              <input
                type="search"
                defaultValue={tableProps.searchText}
                onChange={(event) => {
                  dispatch(search(event.currentTarget.value));
                }}
                placeholder=" Search"
                className="border rounded w-5/12 mb-2 h-10 mr-3 focus:outline-none focus:none pl-1 font-light align-bottom"
              />
              <img
                src="/img/search-2.svg"
                alt=""
                className="absolute w-4 h-4  right-5  bottom-5"
              ></img>
            </span>
          </div>
        </div>
        <div className="p-2 text-xs usersList gridList overflow-x-auto">
          <Table
            {...tableProps}
            childComponents={{
              cellText: {
                content: (props) => {
                  // eslint-disable-next-line default-case
                  switch (props.column.key) {
                    case "Actions":
                      return <CustomCell {...props} />;
                  }
                },
              },
            }}
            dispatch={dispatch}
          />
        </div>
      </div>
    </>
  );
};

export default withRouter(
  connect(
    () => ({}),
    (dispatch) => {
      return bindActionCreators({}, dispatch);
    }
  )(NonFormList)
);
